import { makeTypes, asyncMac, mac, createReducer, reduceReducers } from 'ducks-maker'
import { createFetch, editFetch, addFetch, selectHOR, removeErrorHOR } from './hors.js'
import { leer, modificar, crear } from '../services/api'

const t = makeTypes('cilindradas')
const FETCH = t('fetch').async()
const EDIT = t('edit').async()
const SELECT = t('select').single()
const ADD = t('add').async()
const REMOVEERROR = t('removeError').single()

const fetchActions = asyncMac(FETCH)
const editActions = asyncMac(EDIT)
const addActions = asyncMac(ADD)
export const removeError = mac(REMOVEERROR)
export const selectCilindrada = mac(SELECT,'payload')

const initialState = {
    data: [],
    fetched: false,
    fetching: false,
}

const fetchReducer = createReducer(initialState, createFetch( FETCH ))
const editReducer = createReducer(initialState, editFetch( EDIT ))
const addReducer = createReducer(initialState, addFetch( ADD ))
const removeErrorReducer= createReducer(initialState, removeErrorHOR({ REMOVEERROR }))
const selectReducer= createReducer(initialState, selectHOR({ SELECT }))

export default reduceReducers(fetchReducer, selectReducer, editReducer, addReducer, removeErrorReducer)

export const fetchCilindradas = () => async (dispatch, getState) => {
    dispatch(fetchActions.start())
    try {
        const data = await leer('/cilindrada')
        dispatch(fetchActions.success(data))
    } catch (error) {
        dispatch(fetchActions.error(error))
    }
}

export const editarCilindradas = (id, values) => async (dispatch, getState) => {
    dispatch(editActions.start())
    try {
        const data = await modificar('/cilindrada', id, values)
        dispatch(editActions.success(data))
    } catch (error) {
        dispatch(editActions.error(error))
    }
}

export const agregarCilindrada = (values) => async (dispatch, getState) => {
    dispatch(addActions.start())
    try {
        const data = await crear('/cilindrada', values)
        dispatch(addActions.success(data))
    } catch (error) {
        dispatch(addActions.error(error))
    }
}
